import { PluginFunction } from 'vue';

function printPage() {
	const documentLink = document.getElementById('page-print-document');
	const documentUrl = documentLink && documentLink.getAttribute('href');

	if (documentUrl) {
		window.location.href = documentUrl;
	} else {
		window.print();
	}

	return false;
}

export const Print: PluginFunction<any> = (Vue, options) => {
	(window as any).printPage = printPage;

	Vue.mixin({
		methods: {
			printPage
		}
	});
}

declare module "vue/types/vue" {
	interface Vue {
		printPage: typeof printPage;
	}
}
